<template>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-12 text-center">
                    <div class="d-flex items-center justify-content-md-center bg-light flex-nowrap overflow-auto p-2 rounded shadow-sm mb-4">
                        <button
                            v-for="(item, index) in tabs"
                            :key="index"
                            class="button m-2 flex-shrink-0 text-truncate"
                            :class="show == item.tab ? 'site-content' : 'altcolor-content'"
                            style="min-width: 120px; max-width: 200px;"
                            @click="show = item.tab"
                        >
                            <span>{{ item.nombre }}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="row">
                <transition name="fade" mode="out-in">
                    <template v-for="(tab, index) in tabs">
                        <div class="col-12" :key="index" v-if="show == tab.tab">
                            <slot :name="setTabName(tab.tab)"></slot>
                        </div>
                    </template>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            tabs: Array,
            initialTab: String
        },
        data() {
            return {
                show: this.initialTab
            }
        },
        methods: {
            setTabName(name) {
                return `${name}`;
            }
        }
    }
</script>